import React from 'react';
import { Button } from 'antd';
import { PlusCircleFilled } from '@ant-design/icons';

const BulkAddUsersButton = ({ disabled, onClick }) => (
  <Button
    className="team_member_add_button bulk-add-button"
    disabled={disabled}
    onClick={onClick}
  >
    <PlusCircleFilled className="plus-icon" />
    <span className="button_text">Bulk Add Users</span>
  </Button>
);

export default BulkAddUsersButton;
